import Vue from 'vue'
import Router from 'vue-router'
import TerAboutUs from 'components/ter/aboutUs/aboutUs'
import TerHome from 'components/ter/home/home'
import TerProduce from 'components/ter/produce/produce'
import TerServer from 'components/ter/server/server'
import Tindex from 'components/ter/tIndex/tIndex'

import PcHome from 'components/pc/home/home'
import PcProduce from 'components/pc/produce/produce'
import PcServer from 'components/pc/server/server'
import PcAboutUs from 'components/pc/aboutUs/aboutUs'
import PcPartner from 'components/pc/partner/partner'
import Pindex from 'components/pc/pIndex/pIndex'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/ter/home'
    },
    {
      path: '/ter',
      component: Tindex,
      children: [
        {
          path: 'home',
          component: TerHome
        },
        {
          path: 'produce',
          component: TerProduce
        },
        {
          path: 'server',
          component: TerServer
        },
        {
          path: 'aboutUs',
          component: TerAboutUs
        }
      ]
    },
    {
      path: '/pc',
      component: Pindex,
      children: [
        {
          path: 'home',
          component: PcHome
        },
        {
          path: 'produce',
          component: PcProduce
        },
        {
          path: 'server',
          component: PcServer
        },
        {
          path: 'aboutUs',
          component: PcAboutUs
        },
        {
          path: 'partner',
          component: PcPartner
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js